import React from 'react';


const IconPlayCircle = ({ className, style, width, height, fill }) => (
  <svg preserveAspectRatio="xMidYMid meet" viewBox="0 0 60 60" width={width} height={height} className={className} style={style} fill={fill}>
    <path d="M30,4A26,26,0,1,1,4,30,26,26,0,0,1,30,4m0-4A30,30,0,1,0,60,30,30,30,0,0,0,30,0ZM46,30,22,15V45Z" />
  </svg>
);

IconPlayCircle.defaultProps = {
  width: 60,
  height: 60,
};

export default IconPlayCircle;



// WEBPACK FOOTER //
// ./src/components/Icons/IconPlayCircle.js